import CustomSvgIcon from './CustomSvgIcon.component';

export default CustomSvgIcon;
